import { render, staticRenderFns } from "./draftSunting.vue?vue&type=template&id=6622f20f"
import script from "./draftSunting.vue?vue&type=script&lang=js"
export * from "./draftSunting.vue?vue&type=script&lang=js"
import style0 from "./draftSunting.vue?vue&type=style&index=0&id=6622f20f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports